import {
	GET_QUALIFICATION_YEARS,
	UPDATE_ACTIVE_QUALIFICATION_YEAR,
	GET_DISAPLAY_STATUS,
	CONTRACT_GLOBALS_ERROR,
	GET_APPOINTMENT_TYPES,
	UPDATED_GROUPING_AND_TYPES,
	AUTH_ERROR,
	ADD_TOAST_MESSAGE,
	CLEAR_TOAST_MESSAGE,
	UPDATE_REFINER_SELECTORS
} from '../Enums/Contracts.Globals.Enums';
import moment from 'moment';
import { compare } from 'utils';

const initState = {
	displayStatus: [],
	errors: [],
	qualification_year: {
		selected: moment().format('YYYY'),
		options: ['2019', '2020', '2021'],
		isLoaded: false,
		active: moment().format('YYYY')
	},
	grouping: '',
	appointment_types: {
		isLoaded: false,
		selected: ['MAR', 'CMK'],
		options: [
			{ key: 'Ad Hoc', value: ['ADHOC'] },
			{ key: 'Appointment Group', value: ['APG'] },
			{ key: 'Invigilator', value: ['INV'] },
			{ key: 'Markers', value: ['MAR', 'CMK'] },
			{ key: 'Verifier', value: ['VER'] }
		]
	},
	authorisation: {
		checked: false,
		authorised: null
	},
	toast: null, // example { variant: "success", message: "Something went well"}
	refiner: {
		selectors: [],
		refinerFields: []
	}
};

const contract_globals = (state = initState, action) => {
	let updated = {};
	let { type, payload } = action;

	switch (type) {
		case GET_QUALIFICATION_YEARS:
			updated = {
				...state,
				qualification_year: {
					isLoaded: true,
					selected: payload.data.current_year,
					active: payload.data.current_year
				},
				authorisation: {
					checked: true,
					authorised: true
				},
				errors: payload.errors
			};
			break;

		case UPDATE_ACTIVE_QUALIFICATION_YEAR:
			updated = {
				...state,
				qualification_year: {
					...state.qualification_year,
					active: payload
				}
			};
			break;

		case UPDATE_REFINER_SELECTORS:
				updated = {
					...state,
					refiner: payload
				};
				break;
	
		case GET_APPOINTMENT_TYPES:
			updated = {
				...state,
				appointment_types: {
					...state.appointment_types,
					options: [...payload.data],
					isLoaded: true
				},
				authorisation: {
					checked: true,
					authorised: true
				},
				errors: payload.errors
			};
            updated.appointment_types.options.sort((first, second) => compare(first.key, second.key));
			break;

		case UPDATED_GROUPING_AND_TYPES:
			updated = {
				...state,
				grouping: payload.data.grouping,
				appointment_types: {
					...state.appointment_types,
					selected: payload.data.types
				}
			};
			break;

		case AUTH_ERROR:
			updated = {
				...state,
				authorisation: {
					checked: true,
					authorised: false
				},
				errors: ['You are not authorised']
			};
			break;

		case CONTRACT_GLOBALS_ERROR:
			updated = {
				...state,
				errors: payload.errors
			};
			break;

		case GET_DISAPLAY_STATUS:
			updated = {
				...state,
				displayStatus: ['Issued', 'On Hold', 'Ready', 'Pending']
			};
			break;
		case ADD_TOAST_MESSAGE: {
			updated = { ...state, toast: payload };
			break;
		}
		case CLEAR_TOAST_MESSAGE: {
			updated = { ...state, toast: null };
			break;
		}
		default:
			return state;
	}
	return updated;
};

export default contract_globals;
